import { ReviewOffer } from "../../amplify/backend/function/offerexpstoreFrontApi/ts/public/offerTypes";
import { hasAnnualSelfSupplyData } from "./selfSupplyChartData";
import {
  evaluateSimplifiedPresentationGate,
  simplifiedExperienceIneligible,
  type SimplifiedExperienceDecision,
} from "./simplifiedExperienceDecision";
import type { SelfSupplyEligibleMarket } from "./selfSupplyEligibility";
import { offerReviewOfferHasBattery } from "./shouldShowSimplifiedOfferReviewPage";
import { shouldShowOfferReviewSystemComparison } from "./shouldShowOfferReviewSystemComparison";

type EvaluateOfferReviewSimplifiedExperienceArgs = {
  offerReviewSimplifiedEnabled: boolean;
  presentationTargets: SelfSupplyEligibleMarket[];
  state: string | undefined;
  utility: string | undefined;
  createdDateCutoff?: string | undefined;
  offerCreatedAt?: string | undefined;
  offer: ReviewOffer | undefined;
};

const evaluateOfferReviewSimplifiedExperience = ({
  offerReviewSimplifiedEnabled,
  presentationTargets,
  state,
  utility,
  createdDateCutoff,
  offerCreatedAt,
  offer,
}: EvaluateOfferReviewSimplifiedExperienceArgs): SimplifiedExperienceDecision => {
  const gate = evaluateSimplifiedPresentationGate({
    offerReviewSimplifiedEnabled,
    presentationTargets,
    state,
    utility,
    createdDateCutoff,
    subjectCreatedAt: offerCreatedAt,
  });

  if (!gate.show) {
    return gate;
  }

  if (!offer) {
    return simplifiedExperienceIneligible("MISSING_OFFER");
  }

  if (offer.additionalSystem) {
    return simplifiedExperienceIneligible("SECOND_SYSTEM");
  }

  if (!hasAnnualSelfSupplyData(offer)) {
    return simplifiedExperienceIneligible("MISSING_SELF_SUPPLY");
  }

  if (
    !shouldShowOfferReviewSystemComparison({
      offer,
      nonSolarView: Boolean(offer.isNonSolar),
      hasBattery: offerReviewOfferHasBattery(offer),
    })
  ) {
    return simplifiedExperienceIneligible("OFFER_PRODUCT_INELIGIBLE");
  }

  return gate;
};

export { evaluateOfferReviewSimplifiedExperience };
export type { EvaluateOfferReviewSimplifiedExperienceArgs };
